/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Ready_BodyInputs */

const en_home_ready_body = /** @type {(inputs: Home_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book online in under a minute, or call Mark directly.`)
};

const es_home_ready_body = /** @type {(inputs: Home_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserva en línea en menos de un minuto, o llama directamente a Mark.`)
};

const de_home_ready_body = /** @type {(inputs: Home_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchen Sie online in weniger als einer Minute oder rufen Sie Mark direkt an.`)
};

const zh_home_ready_body = /** @type {(inputs: Home_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一分钟内在线预订，或直接致电 Mark。`)
};

const ar_home_ready_body = /** @type {(inputs: Home_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`احجز عبر الإنترنت في أقل من دقيقة، أو اتصل بـ Mark مباشرة.`)
};

const fr_home_ready_body = /** @type {(inputs: Home_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réservez en ligne en moins d'une minute ou appelez Mark directement.`)
};

const vi_home_ready_body = /** @type {(inputs: Home_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đặt trực tuyến trong chưa đầy một phút, hoặc gọi trực tiếp cho Mark.`)
};

const sw_home_ready_body = /** @type {(inputs: Home_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weka nafasi mtandaoni kwa chini ya dakika moja, au piga simu Mark moja kwa moja.`)
};

const th_home_ready_body = /** @type {(inputs: Home_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จองออนไลน์ภายในไม่กี่นาทีหรือโทรหา Mark โดยตรง`)
};

const bs_home_ready_body = /** @type {(inputs: Home_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervišite online za manje od minute, ili nazovite Marka direktno.`)
};

const ja_home_ready_body = /** @type {(inputs: Home_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オンラインでご予約いただくか、Markを直接お電話ください。`)
};

const ko_home_ready_body = /** @type {(inputs: Home_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1분 안에 온라인으로 예약하거나 Mark에게 직접 전화하세요.`)
};

const pt_home_ready_body = /** @type {(inputs: Home_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agende online em menos de um minuto ou ligue diretamente para Mark.`)
};

const it_home_ready_body = /** @type {(inputs: Home_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prenota online in meno di un minuto, o chiama Mark direttamente.`)
};

const sv_home_ready_body = /** @type {(inputs: Home_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boka online på under en minut eller ring Mark direkt.`)
};

const nl_home_ready_body = /** @type {(inputs: Home_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boek binnen een minuut online, of bel Mark direct.`)
};

const da_home_ready_body = /** @type {(inputs: Home_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestil online på under et minut, eller ring til Mark direkte.`)
};

const nb_home_ready_body = /** @type {(inputs: Home_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestill på nettet i løpet av et minutt, eller ring Mark direkte.`)
};

const fi_home_ready_body = /** @type {(inputs: Home_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varaa verkossa alle minuutin, tai soita suoraan Mark.`)
};

const pl_home_ready_body = /** @type {(inputs: Home_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarezerwuj online w ciągu minuty, lub zadzwoń bezpośrednio do Marka.`)
};

const ru_home_ready_body = /** @type {(inputs: Home_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Забронируйте урок онлайн меньше чем за минуту или позвоните тренеру Mark напрямую.`)
};

const tr_home_ready_body = /** @type {(inputs: Home_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online bir dakikanın altında rezervasyon yapın veya Mark'ı doğrudan arayın.`)
};

const hi_home_ready_body = /** @type {(inputs: Home_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक मिनट से भी कम समय में ऑनलाइन बुक करें, या सीधे Mark को कॉल करें।`)
};

const id_home_ready_body = /** @type {(inputs: Home_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesan online dalam waktu kurang dari semenit, atau hubungi Mark langsung.`)
};

const ms_home_ready_body = /** @type {(inputs: Home_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempah dalam talian dalam masa kurang seminit, atau hubungi Mark terus.`)
};

const cs_home_ready_body = /** @type {(inputs: Home_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervujte online během minuty, nebo zavolejte Markovi přímo.`)
};

const el_home_ready_body = /** @type {(inputs: Home_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κάντε κράτηση online σε λιγότερο από ένα λεπτό, ή καλέστε τον Mark άμεσα.`)
};

const he_home_ready_body = /** @type {(inputs: Home_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הזמינו אונליין בפחות מדקה, או התקשרו ישירות ל-Mark.`)
};

const af_home_ready_body = /** @type {(inputs: Home_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bespreek aanlyn in minder as 'n minuut, of bel Mark direk.`)
};

const hu_home_ready_body = /** @type {(inputs: Home_Ready_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foglaljon online egy perc alatt, vagy hívja Markot.`)
};

/**
* | output |
* | --- |
* | "Book online in under a minute, or call Mark directly." |
*
* @param {Home_Ready_BodyInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_ready_body = /** @type {((inputs?: Home_Ready_BodyInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Ready_BodyInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_ready_body(inputs)
	if (locale === "de") return de_home_ready_body(inputs)
	if (locale === "zh") return zh_home_ready_body(inputs)
	if (locale === "ar") return ar_home_ready_body(inputs)
	if (locale === "fr") return fr_home_ready_body(inputs)
	if (locale === "vi") return vi_home_ready_body(inputs)
	if (locale === "sw") return sw_home_ready_body(inputs)
	if (locale === "th") return th_home_ready_body(inputs)
	if (locale === "bs") return bs_home_ready_body(inputs)
	if (locale === "ja") return ja_home_ready_body(inputs)
	if (locale === "ko") return ko_home_ready_body(inputs)
	if (locale === "pt") return pt_home_ready_body(inputs)
	if (locale === "it") return it_home_ready_body(inputs)
	if (locale === "sv") return sv_home_ready_body(inputs)
	if (locale === "nl") return nl_home_ready_body(inputs)
	if (locale === "da") return da_home_ready_body(inputs)
	if (locale === "nb") return nb_home_ready_body(inputs)
	if (locale === "fi") return fi_home_ready_body(inputs)
	if (locale === "pl") return pl_home_ready_body(inputs)
	if (locale === "ru") return ru_home_ready_body(inputs)
	if (locale === "tr") return tr_home_ready_body(inputs)
	if (locale === "hi") return hi_home_ready_body(inputs)
	if (locale === "id") return id_home_ready_body(inputs)
	if (locale === "ms") return ms_home_ready_body(inputs)
	if (locale === "cs") return cs_home_ready_body(inputs)
	if (locale === "el") return el_home_ready_body(inputs)
	if (locale === "he") return he_home_ready_body(inputs)
	if (locale === "af") return af_home_ready_body(inputs)
	if (locale === "hu") return hu_home_ready_body(inputs)
	return en_home_ready_body(inputs)
});